import { useEffect, useState } from "react";

const Dropdown = (props) =>{
    console.log(props.isSelected)
    const [open, setOpen] = useState(false);
    const [start, setStart] = useState(false);
    const toggleDropdown = () =>{
        props.handleClick();
        setStart(true);
        setOpen(!open);
    }

    useEffect(()=>{
        !props.toggle?setOpen(false):null
    },[props.toggle])
    const icon = <div className={start?open?"toggleDiv":"toggleDivBack":null}>&#9660;</div>
    return(
        <>
            <button onClick={toggleDropdown} className={`${props.primary?"configurator-button-primary":"configurator-button-secondary"} configurator-dropdown ${props.light?props.isSelected?"":"light-option":""}`}>
                {props.label}
                {props.expandable?icon:<span></span>}
            </button>
            {open?props.child:null}
        </>
    )
}
export default Dropdown;